import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Institution} from "../../../../../../models/institution";
import {InstitutionUnit} from "../../../../../../models/Institution-unit";
import {Registration} from "../../../../../../models/registration";
import {RegistrationUnit} from "../../../../../../models/registration-unit";
import {Role} from "../../../../../../models/role";
import {RoleInstitution} from "../../../../../../models/role-institution";
import {RoleUnitControllerService} from "../../../../../../services/role-controller/role-unit-controller.service";
import {Store} from "../../../../../../services/store.service";
import {UnitControllerService} from "../../../../../../services/unit-controller/unit-controller.service";
import {RegistrationUnitControllerService} from "../../../../../../services/unit-controller/unit-registration-controller.service";
import {UnitService} from "../../../../../../services/unit-controller/unit.service";
import {environment} from "../../../../../../../environments/environment";
import {InstitutionControllerService} from "../../../../../../services/institution-controller/institution-controller.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "unit-edit",
  templateUrl: "./unit-edit.component.html",
  styles: [],
  providers: [ToastrService, RoleUnitControllerService],
})
export class UnitEditComponent extends TranslatedBaseError implements OnInit {

  @Input() public institutionUnit: InstitutionUnit;

  public registration: Registration;
  @Input() public registrationInstitutions: Institution[];

  @Input() public registrationUnits: RegistrationUnit[];

  @Input() public role: Role;
  @Input() public roleInstitutions: RoleInstitution[];
  public roleInstitution: RoleInstitution;

  @Input() public context: string;
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();

  public addNew: boolean;

  public subscription: any;

  public isLoading: boolean = false;
  public keycloakActive: boolean = Boolean(environment.KEYCLOAK_ACTIVE);

  constructor(private registrationUnitControllerService: RegistrationUnitControllerService,
              private roleUnitControllerService: RoleUnitControllerService,
              private institutionControllerService: InstitutionControllerService,
              private unitControllerService: UnitControllerService,
              private unitService: UnitService,
              public store: Store,
              public toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.unitService.editData.subscribe((data) => {
      this.institutionUnit = data.institutionUnit;

      this.registration = data.registration;
      this.registrationInstitutions = data.registrationInstitutions;
      this.registrationUnits = data.registrationUnits;

      if (!this.role) { this.role = data.role; }
      if (!this.roleInstitutions) { this.roleInstitutions = data.roleInstitutions; }

      this.context = data.context;
      this.addNew = data.addNew;
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public submit() {
    if (!this.institutionUnit.name) {
      this.showErrorMessage("Name is missing!");
    } else if (this.institutionUnit.url && !this.institutionUnit.url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm)) {
      this.showErrorMessage("Url " + this.institutionUnit.url + " is invalid!");
    } else {
      if (this.context === "registration") {
        this.institutionUnit.institution_id = this.registrationInstitutions[0].id;
      } else if (this.context === "role") {
        this.institutionUnit.institution_id = this.unitService.roleInstitution.institutionId;
      }
      if (!this.institutionUnit.url) {
        this.institutionUnit.url = null;
      }
      if (this.institutionUnit.id === undefined) {
        this.createUnit(this.institutionUnit);
      } else {
        this.editInstitutionUnit(this.institutionUnit);
      }
    }
  }

  private createUnitCas(institutionUnit: InstitutionUnit) {
      return this.unitControllerService.createInstitutionUnit(institutionUnit).subscribe(
          (data) => {
              return this.createUnitCommonCb(JSON.parse(data));
          },
          (error) => {
              this.isLoading = false;
              this.showErrorMessage(error);
          },
      );
  }

    private createUnitKeycloak(unit: InstitutionUnit) {
        const newInstitution = new Institution();
        newInstitution.url = unit.url;
        newInstitution.name = unit.name;
        return this.institutionControllerService.createInstitutionUnit(unit.institution_id, newInstitution).subscribe(
            (data) => {
                // empty response from keycloak here.
                if (data.status !== 201) {
                    this.isLoading = false;
                    this.showErrorMessage(data.statusText);
                    return;
                }
                unit.id = data.headers.get("location").substring(data.headers.get("location").lastIndexOf("/") + 1);
                return this.createUnitCommonCb(unit);
            }, (error) => {
                this.isLoading = false;
                this.showErrorMessage(error);
            },
        );
    }

  private createUnitCommonCb(unit: InstitutionUnit) {
      if (this.registration && this.registration.id) {
          this.addRegistrationUnit(unit);
      } else if (this.role && this.role.id) {
          this.addRoleUnit(unit);
      } else {
          this.responseSuccessful("Unit created!");
          this.formSubmit.emit({ save: true, unit, create: true });
      }
  }

  public createUnit(institutionUnit: InstitutionUnit) {
    if (!this.isLoading) {
      this.isLoading = true;
      if (this.keycloakActive) {
          return this.createUnitKeycloak(institutionUnit);
      }
      return this.createUnitCas(institutionUnit);
    }
  }

  private editInstitutionUnitCas(institutionUnit: InstitutionUnit) {
      this.unitControllerService.updateInstitutionUnit(institutionUnit).subscribe(
          (data) => {
              this.formSubmit.emit({ save: true, institutionUnit: data, create: false });
              this.unitService.updateData();
              this.responseSuccessful("Unit saved!");
              this.resetForm();
          },
          (error) => this.showErrorMessage(error),
      );
  }

  private editInstitutionUnitKeycloak(unit: InstitutionUnit) {
      const institution = new Institution();
      institution.id = unit.id;
      institution.name = unit.name;
      institution.url = unit.url;
      this.institutionControllerService.updateInstitution(institution).subscribe(
          (data) => {
              this.formSubmit.emit({ save: true, institutionUnit: data, create: false });
              this.roleInstitutions?.forEach((ri) => {
                const changedUnit = ri.units.find((u) => u.id === unit.id);
                if (changedUnit) { changedUnit.name = unit.name; }
              });
              this.responseSuccessful("Unit saved!");
              if (!this.roleInstitutions) { this.unitService.updateData(); }
              this.resetForm();

          },
          (error) => this.showErrorMessage(error),
      );
  }

  public editInstitutionUnit(institutionUnit: InstitutionUnit) {
    if (this.keycloakActive) {
      return this.editInstitutionUnitKeycloak(institutionUnit);
    }
    return this.editInstitutionUnitCas(institutionUnit);
  }

  public addRegistrationUnit(institutionUnit) {
    if (this.registration) {
      const newRegUnit: RegistrationUnit = new RegistrationUnit();
      newRegUnit.registrationId = this.registration.id;
      newRegUnit.institutionId = institutionUnit.institution_id;
      newRegUnit.unitId = institutionUnit.id;
      if (this.registrationUnits.length > 0) {
        const activeRegUnitId = this.registrationUnits[0].id;
        this.registrationUnitControllerService.createRegistrationUnit(this.registration.id, newRegUnit).subscribe(
              (createData) => {
                this.responseSuccessful("Unit added to Registration!");
                this.formSubmit.emit({ save: true, institutionUnit: createData, create: true });
                this.unitService.updateData();
                this.resetForm();
              },
              (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
              () => this.isLoading = false,
            );
      } else {
        this.registrationUnitControllerService.createRegistrationUnit(this.registration.id, newRegUnit).subscribe(
          (data) => {
            this.responseSuccessful("Unit added to Registration!");
            this.formSubmit.emit({ save: true, institutionUnit: data, create: true });
            this.unitService.updateData();
            this.resetForm();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
          () => this.isLoading = false,
        );
      }
    }
  }

  public addRoleUnit(institutionUnit: InstitutionUnit) {
    if (this.role.id) {
      const newRoleUnit: RoleInstitution = new RoleInstitution();
      newRoleUnit.id = this.unitService.roleInstitution.id;
      newRoleUnit.institutionId = institutionUnit.institution_id;
      newRoleUnit.unitId = institutionUnit.id;
      newRoleUnit.roleId = this.role.id;

      this.roleUnitControllerService.saveRoleUnit(this.role.id, newRoleUnit).subscribe(
        (createData) => {
          this.responseSuccessful("Unit added to Role!");
          this.formSubmit.emit({ save: true, institutionUnit: createData, create: true });
          this.unitService.roleInstitution.unitId = institutionUnit.id;
          this.unitService.roleInstitution.units.push(institutionUnit);
          this.resetForm();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
        () => this.isLoading = false,
      );
    }
  }

  public resetForm() {
    this.institutionUnit = null;
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
    this.resetForm();
  }

}
